// extracted by mini-css-extract-plugin
export default {"cls1":"SQdcL00OLIupCYby4EDO","cls2":"iyVtfKCV4TxLQRQWLWm3 SQdcL00OLIupCYby4EDO"};